import React, { useState } from "react";
import ConfettiExplosion from "react-confetti-explosion";

function PrimaryButton({
  type,
  disabled,
  children,
  onClick,
  className,
  startIcon,
  mobile = false,
  confetti = false,
  shimmer = false, // New shimmer parameter
  big = false, // New big parameter
}) {
  const [confettiState, setConfettiState] = useState(false);

  const baseClasses =
    "flex items-center shadow-md text-h3 min-w-fit font-medium border-0 transition-all duration-200 ease-in-out";
  const mobileClasses = mobile
    ? "px-4 py-1 rounded-full bg-black text-white hover:bg-gray-500"
    : big
      ? "px-4 py-2 rounded-lg  text-white  bg-indigo-500 hover:bg-indigo-400"
      : "px-3 py-1 rounded-lg  text-white  bg-indigo-500 hover:bg-indigo-400";
  //bg-[#2d2ed2] hover:bg-[#4949ef]
  const shadowClasses =
    "shadow-[0px_1px_5px_rgba(0,0,0,0.2)] hover:shadow-[0_0_0_0.2rem_rgba(0,0,0,0.2)]";
  const disabledClasses = disabled
    ? "opacity-50 cursor-not-allowed"
    : "cursor-pointer";
  const shimmerClasses = shimmer
    ? "relative overflow-hidden animate-pulse min-w-fit"
    : "";

  const buttonClasses = `${baseClasses} ${mobileClasses} ${shadowClasses} ${disabledClasses} ${shimmerClasses} ${
    className || ""
  }`;

  return (
    <button
      type={type}
      disabled={disabled}
      className={buttonClasses}
      onClick={(e) => {
        onClick && onClick(e), confetti && setConfettiState(true);
      }}
    >
      <div className="flex flex-row gap-2 items-center">
        {" "}
        {confettiState && <ConfettiExplosion />}
        {startIcon}
        {children}
      </div>
    </button>
  );
}

export default PrimaryButton;
